import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getAttrValue } from '@grandvisionhq/utils';
import '@grandvisionhq/fun-products';
import { getPrescriptionState } from './utils/get-prescription-state.js';
import '@grandvisionhq/inventory';

const useLenses = ({ product , cartDiscounts , isPrescriptionEnabled , isPrescriptionInfoEnabled , variant  })=>{
    var ref;
    const packageQuantity = Number(getAttrValue(product.masterVariant, 'packageQuantity'));
    /**
   * Stores the pack price, this updates when a different pack size is selected
   */ const [packPrice, setPackPrice] = React.useState((ref = product.masterVariant.prices) === null || ref === void 0 ? void 0 : ref[0]);
    const [clbbPrice, setCLBBPrice] = React.useState();
    /**
   * Selected prescription state which keeps track of the selected lenses
   * and the corresponding prices
   */ const [lensesState, setLensesState] = React.useState({
        packageQuantity,
        selectedProducts: [],
        totalPrice: 0,
        totalCLBBPrice: 0,
        totalDiscount: undefined
    });
    /**
   * Keeps track of the availability and the selected lenses,
   * these are used in the DeliveryIndicator
   */ const [availability1, setAvailability] = React.useState([]);
    const [selectedLensVariants, setSelectedLensVariants] = React.useState([]);
    /**
   * Keeps track of the error states for the configurator and prescriptionInfo,
   * the error count is used for re-rendering the error Alert components
   */ const [formValidations, setFormValidations] = React.useState({
        errorCount: 0,
        hasError: false,
        showError: false,
        isConfiguratorValid: false,
        isPrescriptionInfoValid: !isPrescriptionEnabled
    });
    /**
   * Click handler assigned to the enter prescription button
   * Clicking this button always means the user has not filled in
   * the requested forms completely.
   */ const handlePrescriptionClick = React.useCallback(()=>{
        setFormValidations((prevState)=>swcHelpers.objectSpread({}, prevState, {
                showError: true,
                errorCount: prevState.errorCount + 1
            })
        );
    }, []);
    /**
   * Keeps track if the user selects quantity discount or not
   * */ const [selectedQuantityDiscount, setSelectedQuantityDiscount] = React.useState();
    /**
   * Contact lens configurator callback
   * This will derive the different states based on the form
   */ const handleFormChange = React.useCallback((config)=>{
        const { prescriptionResult , availability , formErrorState , selectedVariantsData  } = getPrescriptionState(config, !!isPrescriptionInfoEnabled, variant, cartDiscounts);
        setSelectedQuantityDiscount(config.selectedQuantityDiscount);
        setPackPrice(config.packPrice);
        setCLBBPrice(config.clbbPrice);
        setLensesState(prescriptionResult);
        setAvailability(availability);
        setSelectedLensVariants(selectedVariantsData);
        setFormValidations((prevState)=>{
            // We only want to show the error if the prevState is marked as showError due to the handlePrescriptionClick
            // If this is the case, keep the showError true until the form is valid
            const showError = prevState.showError && !formErrorState.isConfiguratorValid;
            return swcHelpers.objectSpread({}, prevState, formErrorState, {
                hasError: !formErrorState.isConfiguratorValid,
                showError
            });
        });
    }, [
        isPrescriptionInfoEnabled,
        variant,
        cartDiscounts
    ]);
    const priceTotals = React.useMemo(()=>({
            calculatedPrice: lensesState.totalPrice,
            calculatedDiscountPrice: lensesState.totalDiscount,
            selectedProducts: lensesState.selectedProducts,
            clbbCalculatedPrice: lensesState.totalCLBBPrice
        })
    , [
        lensesState
    ]);
    const state = React.useMemo(()=>({
            availability: availability1,
            hasLenses: !!lensesState.selectedProducts.length,
            formValidations,
            packPrice,
            clbbPrice,
            priceTotals,
            selectedLensVariants,
            selectedQuantityDiscount
        })
    , [
        availability1,
        lensesState,
        formValidations,
        packPrice,
        clbbPrice,
        priceTotals,
        selectedLensVariants,
        selectedQuantityDiscount, 
    ]);
    const handles = React.useMemo(()=>({
            handleFormChange,
            handlePrescriptionClick
        })
    , [
        cartDiscounts
    ]);
    return React.useMemo(()=>[
            state,
            handles
        ]
    , [
        handles,
        state
    ]);
};

export { useLenses };
//# sourceMappingURL=hooks.js.map
